import { showConsoleError } from "../util/ConsoleMessage";
import { Category, SubCategory } from "../util/ExampleData";
import { updateHslaValues, hexToHsla } from "../util/ExtensionFunction";
import { Endpoint } from "./util/contants";
import { apiGetRequest } from "./util/apiUtils";

export const getAllCategories = async (): Promise<Category[] | undefined> => {
  try {
    const res = await apiGetRequest<Category[]>(Endpoint.Category);
    res?.map((data) => {
      if (data.color) {
        data.colorDetails = {
          borderColor: updateHslaValues(hexToHsla(data.color), 25, 90),
          lightColor: hexToHsla(data.color),
          darkColor: updateHslaValues(hexToHsla(data.color), 86, 30),
        };
      }
    });
    return res;
  } catch (error) {
    showConsoleError("Error in All Categories:", error);
    return undefined;
  }
};

export const getSubCategories = async (
  pathVariables: Record<string, any> = {},
  queryParams: Record<string, any> = {}
): Promise<SubCategory[] | undefined> => {
  try {
    return await apiGetRequest<SubCategory[]>(
      Endpoint.SubCategory,
      pathVariables,
      queryParams
    );
  } catch (error) {
    showConsoleError("Error in All Categories:", error);
    return undefined;
  }
};
